export function getXAxisLabel(dateStr: string): string {
    if (!dateStr) return '';

    const [year, month] = dateStr.split('-');
    const date = new Date(`${year}-${month}-01`);

    const monthFormatter = new Intl.DateTimeFormat('ru-RU', { month: 'long' });
    const monthName = monthFormatter.format(date);

    return `${monthName} ${year}`; // "январь 2023"
}

export function getChartTooltipDate(input: string): string {
    if (!input) {
        return '';
    }

    const [year, month, day] = input.split('-');

    return `${day}.${month}.${year}`;
}
